<ng-container *ngIf="(account$ | async) as account; else contentLoading">

  <p-table 
    #charitiesTable 
    [value]="account.data.charities" 
    [globalFilterFields]="['name']"
    styleClass="mt-5 p-datatable-striped" 
    dataKey="_meta.id" 
    responsiveLayout="scroll"
  >

    <ng-template pTemplate="caption">
      <div class="p-d-flex">
        <span class="p-input-icon-left p-ml-auto">
          <i class="pi pi-search"></i>
          <input pInputText type="text" (input)="charitiesTable.filterGlobal($any($event).target.value, 'contains')" placeholder="Search keyword" />
        </span>
      </div>
    </ng-template>

    <ng-template pTemplate="body" let-charity>
      <tr [pSelectableRow]="charity">
        <td class="charity-text">{{ charity.name }}</td>
        <td class="charity-actions">
          <button pButton pRipple type="button" icon="pi pi-pencil" (click)="onEditCharity($event, charity)" class="p-button-rounded p-button-text"></button>
          <button *ngIf="!charity.disabled" pButton pRipple type="button" icon="pi pi-trash" (click)="onDeleteCharity($event, charity)" class="p-button-rounded p-button-danger p-button-text"></button>
          <button *ngIf="charity.disabled" pButton pRipple type="button" icon="pi pi-refresh" (click)="onRestoreCharity($event, charity)" class="p-button-rounded p-button-success p-button-text"></button>
        </td>
      </tr>
    </ng-template>

  </p-table>

</ng-container>
<!-- Shown while the account loads. Without it the modal opens onto an empty
     body for a second or two, which reads as broken rather than busy. -->
<ng-template #contentLoading>
  <div class="flex flex-column align-items-center justify-content-center p-6 text-500">
    <i class="pi pi-spin pi-spinner text-3xl mb-3" aria-hidden="true"></i>
    <span>Loading…</span>
  </div>
</ng-template>
